var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlendGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 285,
    viewBox: "0 0 245 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-101.108 98.7155C-18.6563 123.424 145.591 189.914 142.968 258.21C140.345 326.506 77.3158 365.181 34.2338 365.682C-16.2168 366.268 -106.623 320.894 -156.859 267.063",
    stroke: "black",
    strokeWidth: 0.426238
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -68.6436,
    cy: 332.974,
    r: 51.4142,
    transform: "rotate(33.1632 -68.6436 332.974)",
    fill: "url(#paint0_linear_312_529)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -65.1553,
    cy: 334.828,
    r: 51.4142,
    transform: "rotate(33.1632 -65.1553 334.828)",
    fill: "url(#paint1_linear_312_529)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -61.6495,
    cy: 336.648,
    r: 51.4142,
    transform: "rotate(33.1632 -61.6495 336.648)",
    fill: "url(#paint2_linear_312_529)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: -58.126,
    cy: 338.431,
    r: 51.4142,
    transform: "rotate(33.1632 -58.126 338.431)",
    fill: "url(#paint3_linear_312_529)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: -54.583,
    cy: 340.178,
    r: 51.4142,
    transform: "rotate(33.1632 -54.583 340.178)",
    fill: "url(#paint4_linear_312_529)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: -51.0225,
    cy: 341.887,
    r: 51.4142,
    transform: "rotate(33.1632 -51.0225 341.887)",
    fill: "url(#paint5_linear_312_529)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: -47.4424,
    cy: 343.558,
    r: 51.4142,
    transform: "rotate(33.1632 -47.4424 343.558)",
    fill: "url(#paint6_linear_312_529)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: -43.8448,
    cy: 345.189,
    r: 51.4142,
    transform: "rotate(33.1632 -43.8448 345.189)",
    fill: "url(#paint7_linear_312_529)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: -40.2295,
    cy: 346.78,
    r: 51.4142,
    transform: "rotate(33.1632 -40.2295 346.78)",
    fill: "url(#paint8_linear_312_529)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: -36.5967,
    cy: 348.329,
    r: 51.4142,
    transform: "rotate(33.1632 -36.5967 348.329)",
    fill: "url(#paint9_linear_312_529)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: -32.9443,
    cy: 349.834,
    r: 51.4142,
    transform: "rotate(33.1632 -32.9443 349.834)",
    fill: "url(#paint10_linear_312_529)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: -29.2745,
    cy: 351.295,
    r: 51.4142,
    transform: "rotate(33.1632 -29.2745 351.295)",
    fill: "url(#paint11_linear_312_529)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: -25.587,
    cy: 352.708,
    r: 51.4142,
    transform: "rotate(33.1632 -25.587 352.708)",
    fill: "url(#paint12_linear_312_529)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: -21.8799,
    cy: 354.072,
    r: 51.4142,
    transform: "rotate(33.1632 -21.8799 354.072)",
    fill: "url(#paint13_linear_312_529)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: -18.1553,
    cy: 355.384,
    r: 51.4142,
    transform: "rotate(33.1632 -18.1553 355.384)",
    fill: "url(#paint14_linear_312_529)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.581,
    cy: 354.502,
    r: 51.4142,
    transform: "rotate(33.1632 77.581 354.502)",
    fill: "url(#paint15_linear_312_529)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.1025,
    cy: 352.712,
    r: 51.4142,
    transform: "rotate(33.1632 81.1025 352.712)",
    fill: "url(#paint16_linear_312_529)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.5654,
    cy: 350.813,
    r: 51.4142,
    transform: "rotate(33.1632 84.5654 350.813)",
    fill: "url(#paint17_linear_312_529)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.9678,
    cy: 348.806,
    r: 51.4142,
    transform: "rotate(33.1632 87.9678 348.806)",
    fill: "url(#paint18_linear_312_529)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.3057,
    cy: 346.693,
    r: 51.4142,
    transform: "rotate(33.1632 91.3057 346.693)",
    fill: "url(#paint19_linear_312_529)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5751,
    cy: 344.478,
    r: 51.4142,
    transform: "rotate(33.1632 94.5751 344.478)",
    fill: "url(#paint20_linear_312_529)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.7743,
    cy: 342.16,
    r: 51.4142,
    transform: "rotate(33.1632 97.7743 342.16)",
    fill: "url(#paint21_linear_312_529)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.897,
    cy: 339.742,
    r: 51.4142,
    transform: "rotate(33.1632 100.897 339.742)",
    fill: "url(#paint22_linear_312_529)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.94,
    cy: 337.225,
    r: 51.4142,
    transform: "rotate(33.1632 103.94 337.225)",
    fill: "url(#paint23_linear_312_529)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.903,
    cy: 334.611,
    r: 51.4142,
    transform: "rotate(33.1632 106.903 334.611)",
    fill: "url(#paint24_linear_312_529)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.778,
    cy: 331.903,
    r: 51.4142,
    transform: "rotate(33.1632 109.778 331.903)",
    fill: "url(#paint25_linear_312_529)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.562,
    cy: 329.1,
    r: 51.4142,
    transform: "rotate(33.1632 112.562 329.1)",
    fill: "url(#paint26_linear_312_529)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.249,
    cy: 326.206,
    r: 51.4142,
    transform: "rotate(33.1632 115.249 326.206)",
    fill: "url(#paint27_linear_312_529)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.837,
    cy: 323.222,
    r: 51.4142,
    transform: "rotate(33.1632 117.837 323.222)",
    fill: "url(#paint28_linear_312_529)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.321,
    cy: 320.151,
    r: 51.4142,
    transform: "rotate(33.1632 120.321 320.151)",
    fill: "url(#paint29_linear_312_529)"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.696,
    cy: 316.995,
    r: 51.4142,
    transform: "rotate(33.1632 122.696 316.995)",
    fill: "url(#paint30_linear_312_529)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.958,
    cy: 313.756,
    r: 51.4142,
    transform: "rotate(33.1632 124.958 313.756)",
    fill: "url(#paint31_linear_312_529)"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.101,
    cy: 310.438,
    r: 51.4142,
    transform: "rotate(33.1632 127.101 310.438)",
    fill: "url(#paint32_linear_312_529)"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.122,
    cy: 307.044,
    r: 51.4142,
    transform: "rotate(33.1632 129.122 307.044)",
    fill: "url(#paint33_linear_312_529)"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.017,
    cy: 303.579,
    r: 51.4142,
    transform: "rotate(33.1632 131.017 303.579)",
    fill: "url(#paint34_linear_312_529)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.78,
    cy: 300.045,
    r: 51.4142,
    transform: "rotate(33.1632 132.78 300.045)",
    fill: "url(#paint35_linear_312_529)"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.413,
    cy: 296.448,
    r: 51.4142,
    transform: "rotate(33.1632 134.413 296.448)",
    fill: "url(#paint36_linear_312_529)"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.907,
    cy: 292.791,
    r: 51.4142,
    transform: "rotate(33.1632 135.907 292.791)",
    fill: "url(#paint37_linear_312_529)"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.263,
    cy: 289.081,
    r: 51.4142,
    transform: "rotate(33.1632 137.263 289.081)",
    fill: "url(#paint38_linear_312_529)"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.476,
    cy: 285.323,
    r: 51.4142,
    transform: "rotate(33.1632 138.476 285.323)",
    fill: "url(#paint39_linear_312_529)"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.548,
    cy: 281.521,
    r: 51.4142,
    transform: "rotate(33.1632 139.548 281.521)",
    fill: "url(#paint40_linear_312_529)"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.476,
    cy: 277.682,
    r: 51.4142,
    transform: "rotate(33.1632 140.476 277.682)",
    fill: "url(#paint41_linear_312_529)"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.259,
    cy: 273.81,
    r: 51.4142,
    transform: "rotate(33.1632 141.259 273.81)",
    fill: "url(#paint42_linear_312_529)"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.899,
    cy: 269.913,
    r: 51.4142,
    transform: "rotate(33.1632 141.899 269.913)",
    fill: "url(#paint43_linear_312_529)"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.397,
    cy: 265.995,
    r: 51.4142,
    transform: "rotate(33.1632 142.397 265.995)",
    fill: "url(#paint44_linear_312_529)"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.753,
    cy: 262.057,
    r: 51.4142,
    transform: "rotate(33.1632 142.753 262.057)",
    fill: "url(#paint45_linear_312_529)"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.97,
    cy: 258.104,
    r: 51.4142,
    transform: "rotate(33.1632 142.97 258.104)",
    fill: "url(#paint46_linear_312_529)"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.929,
    cy: 254.155,
    r: 51.4142,
    transform: "rotate(33.1632 142.929 254.155)",
    fill: "url(#paint47_linear_312_529)"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.526,
    cy: 250.225,
    r: 51.4142,
    transform: "rotate(33.1632 142.526 250.225)",
    fill: "url(#paint48_linear_312_529)"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.786,
    cy: 246.346,
    r: 51.4142,
    transform: "rotate(33.1632 141.786 246.346)",
    fill: "url(#paint49_linear_312_529)"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.735,
    cy: 242.539,
    r: 51.4142,
    transform: "rotate(33.1632 140.735 242.539)",
    fill: "url(#paint50_linear_312_529)"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.407,
    cy: 238.821,
    r: 51.4142,
    transform: "rotate(33.1632 139.407 238.821)",
    fill: "url(#paint51_linear_312_529)"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.831,
    cy: 235.2,
    r: 51.4142,
    transform: "rotate(33.1632 137.831 235.2)",
    fill: "url(#paint52_linear_312_529)"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.036,
    cy: 231.682,
    r: 51.4142,
    transform: "rotate(33.1632 136.036 231.682)",
    fill: "url(#paint53_linear_312_529)"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.054,
    cy: 228.267,
    r: 51.4142,
    transform: "rotate(33.1632 134.054 228.267)",
    fill: "url(#paint54_linear_312_529)"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.905,
    cy: 224.954,
    r: 51.4142,
    transform: "rotate(33.1632 131.905 224.954)",
    fill: "url(#paint55_linear_312_529)"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.614,
    cy: 221.739,
    r: 51.4142,
    transform: "rotate(33.1632 129.614 221.739)",
    fill: "url(#paint56_linear_312_529)"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.196,
    cy: 218.617,
    r: 51.4142,
    transform: "rotate(33.1632 127.196 218.617)",
    fill: "url(#paint57_linear_312_529)"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.667,
    cy: 215.585,
    r: 51.4142,
    transform: "rotate(33.1632 124.667 215.585)",
    fill: "url(#paint58_linear_312_529)"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.04,
    cy: 212.636,
    r: 51.4142,
    transform: "rotate(33.1632 122.04 212.636)",
    fill: "url(#paint59_linear_312_529)"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.327,
    cy: 209.766,
    r: 51.4142,
    transform: "rotate(33.1632 119.327 209.766)",
    fill: "url(#paint60_linear_312_529)"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.536,
    cy: 206.971,
    r: 51.4142,
    transform: "rotate(33.1632 116.536 206.971)",
    fill: "url(#paint61_linear_312_529)"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.679,
    cy: 204.246,
    r: 51.4142,
    transform: "rotate(33.1632 113.679 204.246)",
    fill: "url(#paint62_linear_312_529)"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.759,
    cy: 201.586,
    r: 51.4142,
    transform: "rotate(33.1632 110.759 201.586)",
    fill: "url(#paint63_linear_312_529)"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.782,
    cy: 198.989,
    r: 51.4142,
    transform: "rotate(33.1632 107.782 198.989)",
    fill: "url(#paint64_linear_312_529)"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.759,
    cy: 196.45,
    r: 51.4142,
    transform: "rotate(33.1632 104.759 196.45)",
    fill: "url(#paint65_linear_312_529)"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.688,
    cy: 193.966,
    r: 51.4142,
    transform: "rotate(33.1632 101.688 193.966)",
    fill: "url(#paint66_linear_312_529)"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5751,
    cy: 191.534,
    r: 51.4142,
    transform: "rotate(33.1632 98.5751 191.534)",
    fill: "url(#paint67_linear_312_529)"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.4267,
    cy: 189.151,
    r: 51.4142,
    transform: "rotate(33.1632 95.4267 189.151)",
    fill: "url(#paint68_linear_312_529)"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.2412,
    cy: 186.814,
    r: 51.4142,
    transform: "rotate(33.1632 92.2412 186.814)",
    fill: "url(#paint69_linear_312_529)"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.0244,
    cy: 184.522,
    r: 51.4142,
    transform: "rotate(33.1632 89.0244 184.522)",
    fill: "url(#paint70_linear_312_529)"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7783,
    cy: 182.272,
    r: 51.4142,
    transform: "rotate(33.1632 85.7783 182.272)",
    fill: "url(#paint71_linear_312_529)"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5049,
    cy: 180.062,
    r: 51.4142,
    transform: "rotate(33.1632 82.5049 180.062)",
    fill: "url(#paint72_linear_312_529)"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.206,
    cy: 177.89,
    r: 51.4142,
    transform: "rotate(33.1632 79.206 177.89)",
    fill: "url(#paint73_linear_312_529)"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.8838,
    cy: 175.754,
    r: 51.4142,
    transform: "rotate(33.1632 75.8838 175.754)",
    fill: "url(#paint74_linear_312_529)"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5381,
    cy: 173.653,
    r: 51.4142,
    transform: "rotate(33.1632 72.5381 173.653)",
    fill: "url(#paint75_linear_312_529)"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.1747,
    cy: 171.585,
    r: 51.4142,
    transform: "rotate(33.1632 69.1747 171.585)",
    fill: "url(#paint76_linear_312_529)"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.7881,
    cy: 169.549,
    r: 51.4142,
    transform: "rotate(33.1632 65.7881 169.549)",
    fill: "url(#paint77_linear_312_529)"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.3857,
    cy: 167.544,
    r: 51.4142,
    transform: "rotate(33.1632 62.3857 167.544)",
    fill: "url(#paint78_linear_312_529)"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9658,
    cy: 165.568,
    r: 51.4142,
    transform: "rotate(33.1632 58.9658 165.568)",
    fill: "url(#paint79_linear_312_529)"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5283,
    cy: 163.621,
    r: 51.4142,
    transform: "rotate(33.1632 55.5283 163.621)",
    fill: "url(#paint80_linear_312_529)"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.0771,
    cy: 161.7,
    r: 51.4142,
    transform: "rotate(33.1632 52.0771 161.7)",
    fill: "url(#paint81_linear_312_529)"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.6103,
    cy: 159.806,
    r: 51.4142,
    transform: "rotate(33.1632 48.6103 159.806)",
    fill: "url(#paint82_linear_312_529)"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.1298,
    cy: 157.938,
    r: 51.4142,
    transform: "rotate(33.1632 45.1298 157.938)",
    fill: "url(#paint83_linear_312_529)"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.6376,
    cy: 156.094,
    r: 51.4142,
    transform: "rotate(33.1632 41.6376 156.094)",
    fill: "url(#paint84_linear_312_529)"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.1318,
    cy: 154.274,
    r: 51.4142,
    transform: "rotate(33.1632 38.1318 154.274)",
    fill: "url(#paint85_linear_312_529)"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6142,
    cy: 152.477,
    r: 51.4142,
    transform: "rotate(33.1632 34.6142 152.477)",
    fill: "url(#paint86_linear_312_529)"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0869,
    cy: 150.702,
    r: 51.4142,
    transform: "rotate(33.1632 31.0869 150.702)",
    fill: "url(#paint87_linear_312_529)"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5458,
    cy: 148.949,
    r: 51.4142,
    transform: "rotate(33.1632 27.5458 148.949)",
    fill: "url(#paint88_linear_312_529)"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.997,
    cy: 147.218,
    r: 51.4142,
    transform: "rotate(33.1632 23.997 147.218)",
    fill: "url(#paint89_linear_312_529)"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4365,
    cy: 145.506,
    r: 51.4142,
    transform: "rotate(33.1632 20.4365 145.506)",
    fill: "url(#paint90_linear_312_529)"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8661,
    cy: 143.816,
    r: 51.4142,
    transform: "rotate(33.1632 16.8661 143.816)",
    fill: "url(#paint91_linear_312_529)"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.288,
    cy: 142.144,
    r: 51.4142,
    transform: "rotate(33.1632 13.288 142.144)",
    fill: "url(#paint92_linear_312_529)"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.70013,
    cy: 140.491,
    r: 51.4142,
    transform: "rotate(33.1632 9.70013 140.491)",
    fill: "url(#paint93_linear_312_529)"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.10247,
    cy: 138.858,
    r: 51.4142,
    transform: "rotate(33.1632 6.10247 138.858)",
    fill: "url(#paint94_linear_312_529)"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.49896,
    cy: 137.242,
    r: 51.4142,
    transform: "rotate(33.1632 2.49896 137.242)",
    fill: "url(#paint95_linear_312_529)"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: -1.11432,
    cy: 135.645,
    r: 51.4142,
    transform: "rotate(33.1632 -1.11432 135.645)",
    fill: "url(#paint96_linear_312_529)"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: -4.73347,
    cy: 134.066,
    r: 51.4142,
    transform: "rotate(33.1632 -4.73347 134.066)",
    fill: "url(#paint97_linear_312_529)"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: -8.36237,
    cy: 132.503,
    r: 51.4142,
    transform: "rotate(33.1632 -8.36237 132.503)",
    fill: "url(#paint98_linear_312_529)"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: -11.9971,
    cy: 130.958,
    r: 51.4142,
    transform: "rotate(33.1632 -11.9971 130.958)",
    fill: "url(#paint99_linear_312_529)"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: -15.6397,
    cy: 129.429,
    r: 51.4142,
    transform: "rotate(33.1632 -15.6397 129.429)",
    fill: "url(#paint100_linear_312_529)"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: -19.2901,
    cy: 127.917,
    r: 51.4142,
    transform: "rotate(33.1632 -19.2901 127.917)",
    fill: "url(#paint101_linear_312_529)"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: -22.9444,
    cy: 126.421,
    r: 51.4142,
    transform: "rotate(33.1632 -22.9444 126.421)",
    fill: "url(#paint102_linear_312_529)"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: -26.6065,
    cy: 124.942,
    r: 51.4142,
    transform: "rotate(33.1632 -26.6065 124.942)",
    fill: "url(#paint103_linear_312_529)"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: -30.2764,
    cy: 123.478,
    r: 51.4142,
    transform: "rotate(33.1632 -30.2764 123.478)",
    fill: "url(#paint104_linear_312_529)"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: -33.9503,
    cy: 122.03,
    r: 51.4142,
    transform: "rotate(33.1632 -33.9503 122.03)",
    fill: "url(#paint105_linear_312_529)"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: -37.6319,
    cy: 120.598,
    r: 51.4142,
    transform: "rotate(33.1632 -37.6319 120.598)",
    fill: "url(#paint106_linear_312_529)"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: -41.3194,
    cy: 119.182,
    r: 51.4142,
    transform: "rotate(33.1632 -41.3194 119.182)",
    fill: "url(#paint107_linear_312_529)"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: -45.0128,
    cy: 117.781,
    r: 51.4142,
    transform: "rotate(33.1632 -45.0128 117.781)",
    fill: "url(#paint108_linear_312_529)"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: -48.712,
    cy: 116.396,
    r: 51.4142,
    transform: "rotate(33.1632 -48.712 116.396)",
    fill: "url(#paint109_linear_312_529)"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: -52.4151,
    cy: 115.026,
    r: 51.4142,
    transform: "rotate(33.1632 -52.4151 115.026)",
    fill: "url(#paint110_linear_312_529)"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: -56.126,
    cy: 113.672,
    r: 51.4142,
    transform: "rotate(33.1632 -56.126 113.672)",
    fill: "url(#paint111_linear_312_529)"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: -59.8428,
    cy: 112.334,
    r: 51.4142,
    transform: "rotate(33.1632 -59.8428 112.334)",
    fill: "url(#paint112_linear_312_529)"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: -63.5635,
    cy: 111.011,
    r: 51.4142,
    transform: "rotate(33.1632 -63.5635 111.011)",
    fill: "url(#paint113_linear_312_529)"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: -67.2901,
    cy: 109.705,
    r: 51.4142,
    transform: "rotate(33.1632 -67.2901 109.705)",
    fill: "url(#paint114_linear_312_529)"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: -71.0245,
    cy: 108.414,
    r: 51.4142,
    transform: "rotate(33.1632 -71.0245 108.414)",
    fill: "url(#paint115_linear_312_529)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_529",
    x1: -52.2757,
    y1: 363.925,
    x2: -23.2,
    y2: 320.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_312_529",
    x1: -48.7875,
    y1: 365.78,
    x2: -19.7118,
    y2: 322.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_312_529",
    x1: -45.2817,
    y1: 367.599,
    x2: -16.2059,
    y2: 324.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_312_529",
    x1: -41.7582,
    y1: 369.383,
    x2: -12.6824,
    y2: 326.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_312_529",
    x1: -38.2152,
    y1: 371.129,
    x2: -9.13946,
    y2: 328.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_312_529",
    x1: -34.6547,
    y1: 372.838,
    x2: -5.57897,
    y2: 329.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_312_529",
    x1: -31.0746,
    y1: 374.51,
    x2: -1.99884,
    y2: 331.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_312_529",
    x1: -27.477,
    y1: 376.141,
    x2: 1.59876,
    y2: 333.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_312_529",
    x1: -23.8617,
    y1: 377.732,
    x2: 5.21405,
    y2: 334.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_312_529",
    x1: -20.2289,
    y1: 379.281,
    x2: 8.84681,
    y2: 336.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_312_529",
    x1: -16.5765,
    y1: 380.786,
    x2: 12.4992,
    y2: 337.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_312_529",
    x1: -12.9067,
    y1: 382.246,
    x2: 16.1691,
    y2: 339.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_312_529",
    x1: -9.21917,
    y1: 383.659,
    x2: 19.8566,
    y2: 340.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_312_529",
    x1: -5.51214,
    y1: 385.023,
    x2: 23.5636,
    y2: 341.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_312_529",
    x1: -1.78753,
    y1: 386.335,
    x2: 27.2882,
    y2: 343.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_312_529",
    x1: 93.9488,
    y1: 385.453,
    x2: 123.025,
    y2: 342.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_312_529",
    x1: 97.4703,
    y1: 383.664,
    x2: 126.546,
    y2: 340.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_312_529",
    x1: 100.933,
    y1: 381.764,
    x2: 130.009,
    y2: 338.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_312_529",
    x1: 104.336,
    y1: 379.757,
    x2: 133.411,
    y2: 336.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_312_529",
    x1: 107.673,
    y1: 377.645,
    x2: 136.749,
    y2: 334.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_312_529",
    x1: 110.943,
    y1: 375.429,
    x2: 140.019,
    y2: 332.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_312_529",
    x1: 114.142,
    y1: 373.111,
    x2: 143.218,
    y2: 330.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_312_529",
    x1: 117.265,
    y1: 370.693,
    x2: 146.341,
    y2: 327.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_312_529",
    x1: 120.308,
    y1: 368.176,
    x2: 149.384,
    y2: 325.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_312_529",
    x1: 123.271,
    y1: 365.563,
    x2: 152.347,
    y2: 322.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_312_529",
    x1: 126.146,
    y1: 362.854,
    x2: 155.222,
    y2: 319.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_312_529",
    x1: 128.929,
    y1: 360.052,
    x2: 158.005,
    y2: 316.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_312_529",
    x1: 131.617,
    y1: 357.158,
    x2: 160.693,
    y2: 314.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_312_529",
    x1: 134.205,
    y1: 354.174,
    x2: 163.28,
    y2: 311.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_312_529",
    x1: 136.689,
    y1: 351.103,
    x2: 165.765,
    y2: 307.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_312_529",
    x1: 139.064,
    y1: 347.946,
    x2: 168.14,
    y2: 304.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_312_529",
    x1: 141.326,
    y1: 344.708,
    x2: 170.402,
    y2: 301.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_312_529",
    x1: 143.468,
    y1: 341.39,
    x2: 172.544,
    y2: 298.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_312_529",
    x1: 145.49,
    y1: 337.996,
    x2: 174.566,
    y2: 294.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_312_529",
    x1: 147.384,
    y1: 334.53,
    x2: 176.46,
    y2: 291.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_312_529",
    x1: 149.148,
    y1: 330.996,
    x2: 178.224,
    y2: 287.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_312_529",
    x1: 150.781,
    y1: 327.399,
    x2: 179.857,
    y2: 284.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_312_529",
    x1: 152.275,
    y1: 323.743,
    x2: 181.351,
    y2: 280.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_312_529",
    x1: 153.631,
    y1: 320.033,
    x2: 182.706,
    y2: 276.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_312_529",
    x1: 154.843,
    y1: 316.274,
    x2: 183.919,
    y2: 273.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_312_529",
    x1: 155.916,
    y1: 312.472,
    x2: 184.991,
    y2: 269.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_312_529",
    x1: 156.843,
    y1: 308.633,
    x2: 185.919,
    y2: 265.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_312_529",
    x1: 157.627,
    y1: 304.762,
    x2: 186.702,
    y2: 261.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_312_529",
    x1: 158.267,
    y1: 300.865,
    x2: 187.343,
    y2: 257.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_312_529",
    x1: 158.765,
    y1: 296.946,
    x2: 187.841,
    y2: 253.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_312_529",
    x1: 159.121,
    y1: 293.008,
    x2: 188.196,
    y2: 249.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_312_529",
    x1: 159.338,
    y1: 289.056,
    x2: 188.413,
    y2: 245.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_312_529",
    x1: 159.296,
    y1: 285.106,
    x2: 188.372,
    y2: 242.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_312_529",
    x1: 158.894,
    y1: 281.177,
    x2: 187.97,
    y2: 238.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_312_529",
    x1: 158.154,
    y1: 277.297,
    x2: 187.23,
    y2: 234.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_312_529",
    x1: 157.103,
    y1: 273.491,
    x2: 186.179,
    y2: 230.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_312_529",
    x1: 155.775,
    y1: 269.772,
    x2: 184.851,
    y2: 226.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_312_529",
    x1: 154.199,
    y1: 266.152,
    x2: 183.275,
    y2: 223.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_312_529",
    x1: 152.404,
    y1: 262.634,
    x2: 181.48,
    y2: 219.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_312_529",
    x1: 150.422,
    y1: 259.219,
    x2: 179.497,
    y2: 216.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_312_529",
    x1: 148.273,
    y1: 255.905,
    x2: 177.349,
    y2: 212.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_312_529",
    x1: 145.982,
    y1: 252.69,
    x2: 175.058,
    y2: 209.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_312_529",
    x1: 143.564,
    y1: 249.569,
    x2: 172.64,
    y2: 206.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_312_529",
    x1: 141.035,
    y1: 246.536,
    x2: 170.111,
    y2: 203.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_312_529",
    x1: 138.408,
    y1: 243.587,
    x2: 167.484,
    y2: 200.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_312_529",
    x1: 135.695,
    y1: 240.718,
    x2: 164.771,
    y2: 197.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_312_529",
    x1: 132.904,
    y1: 237.922,
    x2: 161.98,
    y2: 194.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_312_529",
    x1: 130.047,
    y1: 235.197,
    x2: 159.122,
    y2: 192.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_312_529",
    x1: 127.127,
    y1: 232.538,
    x2: 156.202,
    y2: 189.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_312_529",
    x1: 124.15,
    y1: 229.94,
    x2: 153.226,
    y2: 186.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_312_529",
    x1: 121.127,
    y1: 227.401,
    x2: 150.202,
    y2: 184.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_312_529",
    x1: 118.056,
    y1: 224.917,
    x2: 147.132,
    y2: 181.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_312_529",
    x1: 114.943,
    y1: 222.485,
    x2: 144.019,
    y2: 179.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_312_529",
    x1: 111.794,
    y1: 220.102,
    x2: 140.87,
    y2: 176.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_312_529",
    x1: 108.609,
    y1: 217.765,
    x2: 137.685,
    y2: 174.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_312_529",
    x1: 105.392,
    y1: 215.474,
    x2: 134.468,
    y2: 172.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_312_529",
    x1: 102.146,
    y1: 213.223,
    x2: 131.222,
    y2: 170.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_312_529",
    x1: 98.8727,
    y1: 211.013,
    x2: 127.948,
    y2: 167.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_312_529",
    x1: 95.5738,
    y1: 208.841,
    x2: 124.65,
    y2: 165.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_312_529",
    x1: 92.2516,
    y1: 206.705,
    x2: 121.327,
    y2: 163.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_312_529",
    x1: 88.9059,
    y1: 204.604,
    x2: 117.982,
    y2: 161.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_312_529",
    x1: 85.5425,
    y1: 202.537,
    x2: 114.618,
    y2: 159.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_312_529",
    x1: 82.1559,
    y1: 200.501,
    x2: 111.232,
    y2: 157.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_312_529",
    x1: 78.7535,
    y1: 198.496,
    x2: 107.829,
    y2: 155.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_312_529",
    x1: 75.3336,
    y1: 196.52,
    x2: 104.409,
    y2: 153.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_312_529",
    x1: 71.8961,
    y1: 194.572,
    x2: 100.972,
    y2: 151.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_312_529",
    x1: 68.4449,
    y1: 192.652,
    x2: 97.5206,
    y2: 149.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_312_529",
    x1: 64.9781,
    y1: 190.758,
    x2: 94.0538,
    y2: 147.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_312_529",
    x1: 61.4976,
    y1: 188.889,
    x2: 90.5734,
    y2: 145.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_312_529",
    x1: 58.0054,
    y1: 187.046,
    x2: 87.0812,
    y2: 143.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_312_529",
    x1: 54.4996,
    y1: 185.225,
    x2: 83.5754,
    y2: 142.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_312_529",
    x1: 50.982,
    y1: 183.429,
    x2: 80.0577,
    y2: 140.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_312_529",
    x1: 47.4547,
    y1: 181.654,
    x2: 76.5305,
    y2: 138.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_312_529",
    x1: 43.9136,
    y1: 179.901,
    x2: 72.9894,
    y2: 136.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_312_529",
    x1: 40.3648,
    y1: 178.169,
    x2: 69.4406,
    y2: 135.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_312_529",
    x1: 36.8043,
    y1: 176.458,
    x2: 65.88,
    y2: 133.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_312_529",
    x1: 33.234,
    y1: 174.767,
    x2: 62.3097,
    y2: 131.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_312_529",
    x1: 29.6558,
    y1: 173.096,
    x2: 58.7316,
    y2: 129.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_312_529",
    x1: 26.0679,
    y1: 171.443,
    x2: 55.1437,
    y2: 128.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_312_529",
    x1: 22.4703,
    y1: 169.809,
    x2: 51.546,
    y2: 126.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_312_529",
    x1: 18.8668,
    y1: 168.194,
    x2: 47.9425,
    y2: 125.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_312_529",
    x1: 15.2535,
    y1: 166.597,
    x2: 44.3292,
    y2: 123.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_312_529",
    x1: 11.6343,
    y1: 165.017,
    x2: 40.7101,
    y2: 121.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_312_529",
    x1: 8.00544,
    y1: 163.455,
    x2: 37.0812,
    y2: 120.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_312_529",
    x1: 4.37068,
    y1: 161.909,
    x2: 33.4464,
    y2: 118.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_312_529",
    x1: 0.728099,
    y1: 160.38,
    x2: 29.8038,
    y2: 117.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_312_529",
    x1: -2.92229,
    y1: 158.868,
    x2: 26.1534,
    y2: 115.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_312_529",
    x1: -6.57659,
    y1: 157.373,
    x2: 22.4991,
    y2: 114.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_312_529",
    x1: -10.2387,
    y1: 155.893,
    x2: 18.837,
    y2: 112.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_312_529",
    x1: -13.9086,
    y1: 154.429,
    x2: 15.1671,
    y2: 111.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_312_529",
    x1: -17.5824,
    y1: 152.982,
    x2: 11.4933,
    y2: 109.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_312_529",
    x1: -21.2641,
    y1: 151.55,
    x2: 7.81165,
    y2: 108.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_312_529",
    x1: -24.9516,
    y1: 150.133,
    x2: 4.12415,
    y2: 107.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_312_529",
    x1: -28.6449,
    y1: 148.732,
    x2: 0.430791,
    y2: 105.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_312_529",
    x1: -32.3442,
    y1: 147.347,
    x2: -3.26843,
    y2: 104.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_312_529",
    x1: -36.0473,
    y1: 145.978,
    x2: -6.97155,
    y2: 102.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_312_529",
    x1: -39.7582,
    y1: 144.623,
    x2: -10.6825,
    y2: 101.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_312_529",
    x1: -43.475,
    y1: 143.285,
    x2: -14.3993,
    y2: 100.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_312_529",
    x1: -47.1957,
    y1: 141.963,
    x2: -18.12,
    y2: 98.8586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_312_529",
    x1: -50.9223,
    y1: 140.656,
    x2: -21.8466,
    y2: 97.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_312_529",
    x1: -54.6567,
    y1: 139.366,
    x2: -25.5809,
    y2: 96.2614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#478CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3EDF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlendGroup1);
export default __webpack_public_path__ + "static/media/Blend Group 1.03392a5c8a9cfabe725957dc8ae322b2.svg";
export { ForwardRef as ReactComponent };